import React from "react";
import PostFooter from "./PostFooter";
import { useParams } from "react-router-dom";
import SideBar from "./SideBar";
import SuggestedArticles from "./SuggestedArticles";
import db from "../../firebase";  
import { useCollectionData } from "react-firebase-hooks/firestore";
import AuthorPreview from "./AuthorPreview";
import AuthorNtime from "./AuthorNtime";

const Post = () => {
  const { title } = useParams();
  const blogsRef = db.collection("blogs");
  const query = blogsRef.where("title", "==", title);
  const [post, loading, error] = useCollectionData(query);
  return (
    <>
      <div className="container p-0" style={{margin: "10vh 1vw 1vh"}}>
        {loading && <h1>Loading...</h1>}
        {error && <h1>{error}</h1>}
        <div className="row m-0" style={{maxWidth: "100%"}}>
          {/* Normal Part of the article */}
          {post && <div className="col-md-9" style={{paddingLeft: "8px", paddingRight: "4px"}}>
            <div className="container-fluid p-0">
              {/* Path */}
              <section className="row"></section>
              {/* Title */}
              <section className="row">
                <h1>{post && post[0].title}</h1>
              </section>
              {/* Description */}
              <section className="row">
                <div dangerouslySetInnerHTML={{__html: post[0].description}} />
              </section>
              {/* Author and Time etc. */}
              <AuthorNtime 
                name={post[0].author}
                time={post[0].createdAt}
              />
              {/* Featured Image */}
              <section className="row">
              <img src={post[0].featuredImg} alt="" />
              </section>
              {/* Post */}
              <section className="row">
                <div dangerouslySetInnerHTML={{__html: post[0].article}} />
              </section>
              {/* Author's about article or portfolio */}
              <AuthorPreview 
                name={post[0].author}
              />
              {/* Suggested articles */}
              <SuggestedArticles />
            </div>
          </div>
          }          
          <SideBar instaArray={post && post[0].instaArray}/>
        </div>
      </div>
      <PostFooter />
    </>
  );
}

export default Post;